import React from 'react';
import { ListCandidate } from '../../../../../../../entities/applicant_tracking/ListCandidate';
import { BulkActionButton } from '../BulkActionButton';
import { bulkApplicationReviewUrl } from '../../../../../../../utils/applicant_tracking/bulkApplicationReview';

interface PropTypes {
  selectedCandidates: ListCandidate[];
}

export function BulkReviewButton(props: PropTypes) {
  const actionDisabled =
    props.selectedCandidates.length === 0 ||
    !props.selectedCandidates.every((c) => c.application?.status === 'active');
  const applicationIds = props.selectedCandidates
    .map((c) => c.application?.id)
    .filter(Boolean);

  return (
    <>
      <BulkActionButton
        iconName='bi-people'
        toolTipText={
          actionDisabled &&
          'Review candidates is only available for active candidates'
        }
        disabled={actionDisabled}
        buttonText='Review Candidates'
        onClick={() =>
          (window.location.href = bulkApplicationReviewUrl(applicationIds))
        }
        analyticsId='bulk-review-button'
      />
    </>
  );
}
